angular.module('mediaTagServiceModule', ['createMediaTagModule', 'mediaTagManagerModule','sysMediaTagSortModule']).factory('mediaTagService', ['$modal', '$q',
    function($modal, $q) {
        return {
            createMediaTag: function(options) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/mediaTag/directive/createMediaTag/index.html',
                    windowClass: 'create-media-tag',
                    backdrop: false,
                    controller: 'createMediaTagCtrl',
                    resolve: {
                        options: function() {
                            return options;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                });
                return defer.promise;
            },

            importMediaTag: function(options) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/mediaTag/directive/importTag/index.html',
                    windowClass: 'import-media-tag',
                    backdrop: false,
                    controller: 'importMediaTagCtrl',
                    resolve: {
                        options: function() {
                            return options;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                });
                return defer.promise;
            },
            
            sort: function(options) {
                var defer = $q.defer();
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/sysManageMent/mediaTag/directive/sort/index.html',
                    windowClass: 'productManageMent-weibo-sort',
                    backdrop: false,
                    controller: 'sysMediaTagSortCtrl',
                    resolve: {
                        options: function() {
                            return options;
                        },
                    },
                });
                modalInstance.result.then(function(result) {
                    defer.resolve(result);
                });
                return defer.promise;
            }
        };
    }
])
;
